<ng-container>
	<app-ea-spinner *ngIf="!user"></app-ea-spinner>
	<!--TODO <my-error-component *ngIf="data.error" [error]="data.error"></my-error-component> -->
	<div *ngIf="user">
		<div class="flex align-items-center justify-content-between pt-3 pb-5 px-4" id="header">
			<div class="pl-3 overflow-hidden">
				<span class="block text-4xl font-bold">{{ user.email }}</span>
				<span class="header block white-space-nowrap overflow-hidden"
					>{{ "cree.le" | translate }} {{ user.created | date : "longDate" }}</span
				>
				<span class="header block white-space-nowrap overflow-hidden"
					>{{ "derniere.maj" | translate }} {{ user.updated | date : "longDate" }}</span
				>
			</div>
		</div>
		<div class="grid p-fluid">
			<div class="col-12 md:col-6 xl:col-6">
				<div class="card">
					<h5>{{ "global.roles" | translate }} : {{ userRole }}</h5>
					<button
						pButton
						pRipple
						label="{{ 'roles.change' | translate }}"
						icon="pi pi-pencil"
						class="p-button-info mb-2 mr-2"
						(click)="updateUserRoles()"></button>

					<button
						pButton
						pRipple
						label="{{ 'user.delete' | translate }}"
						icon="pi pi-user-minus"
						class="p-button-danger mb-2"
						(click)="deleteUser()"></button>
				</div>
			</div>
			<div class="col-12 md:col-6 xl:col-6">
				<div class="card">
					<p-toast></p-toast>
					<h5 style="display: inline-block">{{ "cheptel.listegeres" | translate }}</h5>
					<p-table
						#dt
						[value]="exploitations"
						[(selection)]="selectedExploitation"
						dataKey="id"
						styleClass="p-datatable-exploitations"
						[rowHover]="true"
						[rows]="15"
						[paginator]="true"
						[filterDelay]="0"
						[globalFilterFields]="['numeroCheptel', 'niveauAcces']">
						<ng-template pTemplate="header">
							<tr>
								<th pSortableColumn="numeroCheptel">
									<div class="flex justify-content-between align-items-center">
										{{ "cheptel.numero" | translate }}
										<p-sortIcon field="numeroCheptel"></p-sortIcon>
										<p-columnFilter
											type="text"
											field="numeroCheptel"
											display="menu"
											class="ml-auto"></p-columnFilter>
									</div>
								</th>
								<th pSortableColumn="niveauAcces">
									<div class="flex justify-content-between align-items-center">
										{{ "global.niveauaccess" | translate }}
										<p-sortIcon field="niveauAcces"></p-sortIcon>
										<p-columnFilter
											type="text"
											field="niveauAcces"
											display="menu"
											class="ml-auto"></p-columnFilter>
									</div>
								</th>
								<th style="width: 10%">{{ "access.editersupprimer" | translate }}</th>
							</tr>
						</ng-template>
						<ng-template pTemplate="body" let-exploitation>
							<tr class="p-selectable-row">
								<td>
									<span class="p-column-title">{{ "cheptel.numero" | translate }}</span>
									<span class="image-text" style="margin-left: 0.5em; vertical-align: middle">{{
										exploitation.numeroCheptel
									}}</span>
								</td>
								<td>
									<span class="p-column-title">{{ "global.niveauaccess" | translate }}</span>
									{{ exploitation.niveauAcces | enumToKey | translate }}
								</td>
								<td class="flex align-items-center justify-content-between pt-3 pb-2 px-4">
									<button
										pButton
										pRipple
										icon="pi pi-pencil"
										class="p-button-rounded p-button-info mr-2"
										(click)="editAccess(exploitation)"></button>
									<button
										pButton
										pRipple
										icon="pi pi-trash"
										class="p-button-rounded p-button-danger"
										(click)="deleteAccess(exploitation)"></button>
									<div></div>
								</td>
							</tr>
						</ng-template>
						<ng-template pTemplate="emptymessage">
							<tr>
								<td colspan="8">{{ "cheptel.listegeres" | translate }}</td>
							</tr>
						</ng-template>
					</p-table>
				</div>
			</div>

			<p-dialog
				[(visible)]="editExploitationAccessDialog"
				[style]="{ width: '450px' }"
				header="Edition d'accès"
				[modal]="true"
				styleClass="p-fluid">
				<ng-template pTemplate="content">
					<div class="field">
						<label class="mb-3">{{ "global.typeaccess" | translate }}</label>
						<div class="formgrid grid">
							<div class="field-radiobutton col-6">
								<p-radioButton
									id="category1"
									name="category"
									value="SAISIE"
									[(ngModel)]="selectedExploitation.niveauAcces"></p-radioButton>
								<label for="category1">{{ "access.saisie" | translate }}</label>
							</div>
							<div class="field-radiobutton col-6">
								<p-radioButton
									id="category2"
									name="category"
									value="CONSULTATION"
									[(ngModel)]="selectedExploitation.niveauAcces"></p-radioButton>
								<label for="category2">{{ "access.consultation" | translate }}</label>
							</div>
						</div>
					</div>
				</ng-template>

				<ng-template pTemplate="footer">
					<button
						pButton
						pRipple
						label="{{ 'global.annuler' | translate }}"
						icon="pi pi-times"
						class="p-button-text"
						(click)="hideAllDialog()"></button>
					<button
						pButton
						pRipple
						label="{{ 'global.enregistrer' | translate }}"
						icon="pi pi-check"
						class="p-button-text"
						(click)="saveExploitationAccess()"></button>
				</ng-template>
			</p-dialog>

			<p-dialog
				[(visible)]="userUpdateDialog"
				[style]="{ width: '450px' }"
				header="Changer les rôles"
				[modal]="true"
				styleClass="p-fluid">
				<ng-template pTemplate="content">
					<div class="field">
						<label class="mb-3">{{ "global.typeaccess" | translate }}</label>
						<div class="formgrid grid">
							<div class="field-radiobutton col-6">
								<p-checkbox
									id="category2"
									name="category"
									value="ELEVEUR"
									[(ngModel)]="currentUserDraft.roles"></p-checkbox>
								<label for="category2">{{ "user.eleveur" | translate }}</label>
							</div>
							<div class="field-radiobutton col-6">
								<p-checkbox
									id="category1"
									name="category"
									value="ADMINISTRATEUR"
									[(ngModel)]="currentUserDraft.roles"></p-checkbox>
								<label for="category1">{{ "user.administrateur" | translate }}</label>
							</div>
						</div>
						<small class="p-invalid red-text" *ngIf="errorRoleType === 'noRoles'">{{
							"submit.champobligatoire" | translate
						}}</small>
					</div>
				</ng-template>

				<ng-template pTemplate="footer">
					<button
						pButton
						pRipple
						label="{{ 'global.annuler' | translate }}"
						icon="pi pi-times"
						class="p-button-text"
						(click)="hideAllDialog()"></button>
					<button
						pButton
						pRipple
						label="{{ 'global.enregistrer' | translate }}"
						icon="pi pi-check"
						class="p-button-text"
						(click)="updateUser()"></button>
				</ng-template>
			</p-dialog>

			<p-confirmDialog [style]="{ width: '450px' }"></p-confirmDialog>
		</div>
	</div>
</ng-container>
